import React, {Component} from 'react';

class Footer extends Component<{},{}>{

    constructor(props: any){
        super(props);
          this.state = {
              
          };
      }

    render(){
        return (
        <footer> 
            <ul className="social">
                <li id="facebook">
                    <a href="https://www.facebook.com/emmaniiistudios/?modal=admin_todo_tour" style={{backgroundImage:"url(/images/facebook.gif)"}}>Facebook</a>
                </li>
                <li id="instagram">
                    <a href="https://www.instagram.com/emmaniii_studios/" style={{backgroundImage:"url(/images/instagram.gif)"}}>Instagram</a>
                </li>
                <li id="youtube">
                    <a href="https://www.youtube.com/channel/UCmZjVSe7uJFj1673p4ykOqQ" style={{backgroundImage:"url(/images/youtube.gif)"}}>Youtube</a>
                </li>
                <li id="discord">
                    <a href="https://discord.gg/ggr8XkX" style={{backgroundImage:"url(/images/Discordicon.png)"}}>Youtube</a>
                </li>
            </ul>
        </footer>
        )
    }
}

export default Footer;